<template>
  <div v-if="test">
    <div class="page-title mb-3">
      진단평가 결과 : {{test.name}} / {{test.code}}
    </div>
    <perform-self-test-view :test="test" :answer="answer"/>
    <div class="text-center"><mdb-btn icon="undo" @click="$router.back()">돌아가기</mdb-btn></div>
  </div>
</template>
<script>
import { } from 'mdbvue';
import { mapState } from 'vuex';
import PerformSelfTestView from '../../../../components/test/performself/PerformSelfTestView.vue';
export default {
  name: 'StudentSelfPerformTestView',
  components: { PerformSelfTestView },
  props: [],
  data: () => ({
    TAG: 'StudentSelfPerformTestView :',
    answer: {},
    code: '',
    test: undefined
  }),
  computed: {
    ...mapState('training', ['subjects'])
  },
  methods: {
    async getTest (code) {
      for (let i = 0; this.subjects.NCS.length; i++) {
        const l = this.subjects.NCS[i].lectures.find(l => l.code === code)
        if (l) {
          this.test = l
          return
        }
      }
    },
    async load () {
      if (!this.subjects.NCS) return
      const { answer } = this.$route.query
      this.answer = await this.$PerformSelfTestAnswer.get(answer)
      this.getTest(this.answer.code)
    }
  },
  created () {
    this.load()
  },
  watch: {
    subjects () { this.load() }
  }
}
</script>
